import React, {useEffect, useState} from 'react'
import { Redirect, useHistory } from 'react-router-dom';
import Loader from '../components/Loader';
import { db } from '../config/fire';
import { Button } from 'antd';

const Waiting = (props) => {
    const { state } = props.history.location;

    const [roomId, setRoomid] = useState("");
    const [time, settime] = useState("");
    const [datas, setData] = useState();

    const [title, settitle] = useState("");

    const [roompass, setroompass] = useState(false);
    const [load, setload] = useState(true);

    const [active, setactive] = useState('');

 
  useEffect(() =>{
    if(state === undefined){
        setData(false);
        setload(false);
    }
    else {
        
        setData(true);
        settitle(state.title)
        setRoomid(state.roomid);
        const roomref = db().ref('all-rooms/'+roomId);
        roomref.on('value', snapshot => {
            const data = snapshot.val();
            console.log('Status', data.status);
             setactive(data.status);
           setroompass(data.auth)
            
        });
        setload(false);
        
    }
    
  },[])
  function join(){
      props.history.push('/room/'+roomId)
  }
    return (
        load ? <Loader /> :
        datas ?<>
         <text>You are Waiting For Meeting({title})</text> 
         {active == 'ACTIVE' ? <>
         <text>Room is ON</text>
          <Button onClick={() => join()}>
             Go And Join
             </Button></>: <text>Wait Bro Not Started Yet {roompass && 
             'By wasting Time Find the pass Whether it need is '} </text>}
         </> : 
        <Redirect to='/'/>
    )
}



export default Waiting;